import { render, staticRenderFns } from "./InterestsCombo.vue?vue&type=template&id=660fb7e1&scoped=true"
import script from "./InterestsCombo.vue?vue&type=script&lang=js"
export * from "./InterestsCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660fb7e1",
  null
  
)

export default component.exports